import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import queryString from 'query-string'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
`

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #3498db;
  animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

const LoadingText = styled.div`
  text-align: center;
  font-size: 16px;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`

const AppRedirectPage = () => {
  const location = useLocation()
  
  useEffect(() => {
    // 쿼리 파라미터 추출
    const query = queryString.parse(location.search)
    const { appLink, fallbackLink } = query
    
    if (!appLink) {
      // 앱 링크가 없으면 메인으로 이동
      window.location.href = '/'
      return
    }
    
    // 폴백 링크로 이동하는 타임아웃 설정
    const timeout = setTimeout(() => {
      window.location.href = fallbackLink || '/'
    }, 1500)

    // 앱 실행 시도
    window.location.href = appLink

    // 앱 실행 감지
    const handleVisibilityChange = () => {
      if (document.hidden || document.visibilityState === 'hidden') {
        clearTimeout(timeout)
      }
    }

    // 여러 이벤트 리스너 등록 (다양한 브라우저/기기 지원)
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('pagehide', () => clearTimeout(timeout))
    window.addEventListener('blur', () => clearTimeout(timeout))

    return () => {
      clearTimeout(timeout)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('pagehide', () => clearTimeout(timeout))
      window.removeEventListener('blur', () => clearTimeout(timeout))
    }
  }, [location.search])

  return (
    <Container>
      <Spinner />
      <LoadingText>앱으로 이동 중입니다...</LoadingText>
    </Container>
  )
}

export default AppRedirectPage
